import React, { useEffect, useState, useRef } from 'react';
export const DailyEssentials = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="relative bg-[#f5f0e5] py-20 overflow-hidden" data-id="element-6">
      {/* Decorative Elements */}
      <div className="absolute top-20 right-20 w-64 h-64 bg-primary/5 rounded-full blur-3xl" data-id="element-7"></div>
      <div className="absolute bottom-20 left-20 w-96 h-96 bg-gold/10 rounded-full blur-3xl" data-id="element-8"></div>
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-9">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-10">
  <div className={`transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'}`} data-id="element-11">
  <div className="inline-flex items-center gap-2 bg-white/60 backdrop-blur-sm text-primary px-4 py-2 rounded-full text-xs font-medium mb-6 border border-primary/10" data-id="element-12">
    <span className="w-2 h-2 bg-primary rounded-full animate-pulse" data-id="element-13"></span>
    Health Starts Here
  </div>
  <h2 className="text-4xl md:text-6xl font-light text-primary mb-6 leading-tight" data-id="element-14">
    Daily Essentials for a Clearer Mind and a Stronger Body.
  </h2>
  <p className="text-text-light text-sm mb-8 leading-relaxed" data-id="element-15">
    Clean, creation-based formulas designed to help you feel steady,
    centered, and ready for any challenge God assigns to you.
  </p>
  
  {/* Updated to anchor tag with href */}
  <a href="https://learnmore.faithandfig.com/" className="inline-block bg-primary text-white px-8 py-3 rounded-full hover:bg-primary/90 transition-all duration-300 text-sm font-medium shadow-lg hover:shadow-xl" data-id="element-16">
    Learn More About Our Mission
  </a>
        </div>
          <div className="grid grid-cols-2 gap-4" data-id="element-17">
            <div className={`col-span-2 relative group overflow-hidden rounded-2xl h-80 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
            transitionDelay: '100ms'
          }} data-id="element-18">
              <img src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/bb4aaa1f-5bfa-4174-93b3-0c5576c8974d.png?v=1763926873" alt="Product bottles" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-19" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-20"></div>
            </div>
            <div className={`relative group overflow-hidden rounded-2xl h-48 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
            transitionDelay: '200ms'
          }} data-id="element-21">
              <img src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/Gemini_Generated_Image_5p98y85p98y85p98.png?v=1763928093" alt="Hand with supplement" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-22" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-23"></div>
            </div>
            <div className={`relative group overflow-hidden rounded-2xl h-48 transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
            transitionDelay: '300ms'
          }} data-id="element-24">
              <img src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/867c10f0-376f-4aab-afa3-eb7942e80ea8.png?v=1763934940" alt="Supplement detail" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-25" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-26"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};